import { COMMENTS_PREVIEW_QUERY_VALUE } from "src/utils/comments-preview";

import { useCommentsPreviewMode } from "./use-comments-preview-mode";

/** Comment count / drawer opener href: `?comments=test` in dev preview, else `#comments`. */
export function useCskCommentsLinkUrl(
  permalink: string | null | undefined,
): string {
  const previewMode = useCommentsPreviewMode();

  if (previewMode && typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    params.set("comments", COMMENTS_PREVIEW_QUERY_VALUE);
    const query = params.toString();
    return query
      ? `${window.location.pathname}?${query}`
      : `${window.location.pathname}?comments=${COMMENTS_PREVIEW_QUERY_VALUE}`;
  }

  return `${permalink ?? ""}#comments`;
}
